/**
 * App config
 */

export const getConfigValue = (key, buildTimeValue, hardcodedDefault) => {
    if (typeof window !== 'undefined' && window.RUNTIME_CONFIG && window.RUNTIME_CONFIG[key] !== undefined && window.RUNTIME_CONFIG[key] !== '') {
        return window.RUNTIME_CONFIG[key];
    }
    if (buildTimeValue !== undefined && buildTimeValue !== '') {
        return buildTimeValue;
    }
    return hardcodedDefault;
};

const {
    MIA_SERVICE_URL,
    DEPLOYMENT_ENV,
    DATADOG_RUM_APPLICATION_ID,
    DATADOG_CLIENT_TOKEN,
    DATADOG_SERVICE,
    DATADOG_ENABLE,
    MIA_FILE_ASSETS_SERVICE_ENDPOINT,
    GOOGLE_MAP_CLIENT_API_KEY,
} = process.env;

export default {
    // General
    VERSION: process.env.APP_VERSION || '',
    BUILD: process.env.APP_BUILD || '',
    PUBLIC_URL: getConfigValue('PUBLIC_URL', process.env.PUBLIC_URL, '/'),
    LOCALE: getConfigValue('LOCALE', process.env.LOCALE, 'de'),
    MIA_SERVICE_URL: getConfigValue('MIA_SERVICE_URL', MIA_SERVICE_URL, undefined),
    DEPLOYMENT_ENV: getConfigValue('DEPLOYMENT_ENV', DEPLOYMENT_ENV, undefined),
    DATADOG_RUM_APPLICATION_ID: getConfigValue('DATADOG_RUM_APPLICATION_ID', DATADOG_RUM_APPLICATION_ID, undefined),
    DATADOG_CLIENT_TOKEN: getConfigValue('DATADOG_CLIENT_TOKEN', DATADOG_CLIENT_TOKEN, undefined),
    DATADOG_SERVICE: getConfigValue('DATADOG_SERVICE', DATADOG_SERVICE, undefined),
    DATADOG_ENABLE: getConfigValue('DATADOG_ENABLE', DATADOG_ENABLE, undefined),
    MIA_FILE_ASSETS_SERVICE_ENDPOINT: getConfigValue('MIA_FILE_ASSETS_SERVICE_ENDPOINT', MIA_FILE_ASSETS_SERVICE_ENDPOINT, undefined),
    GOOGLE_MAP_CLIENT_API_KEY: getConfigValue('GOOGLE_MAP_CLIENT_API_KEY', GOOGLE_MAP_CLIENT_API_KEY, undefined),
    initialResubmitCount: -1,
    defaultServiceCasesPage: 1,
    defaultServiceCasesPageSize: 10,
    defaultNumberOfFirstPages: 2,
    defaultNumberOfLastPages: 2,
    MIA_LOCALE_TRANSLATION_EN_US_URL: getConfigValue('MIA_LOCALE_TRANSLATION_EN_US_URL', process.env.MIA_LOCALE_TRANSLATION_EN_US_URL, undefined),
    MIA_LOCALE_TRANSLATION_DE_DE_URL: getConfigValue('MIA_LOCALE_TRANSLATION_DE_DE_URL', process.env.MIA_LOCALE_TRANSLATION_DE_DE_URL, undefined),
    minRegistrationDate: '1.1.1900',
    GERMANY_BOUNDING_BOX: {
        east: 15,
        north: 55,
        south: 47,
        west: 5,
    },
    MAX_FILE_SIZE: 20971520,
    MAX_NUMBER_OF_FILES: 10,
};
